import { axiosInstance } from '@/rest'

// Documents REST API client

const createDocumentsApi = () => {
  return {
    /**
     * Get documents for an account
     * @param {string} accountNumber
     * @param {string} documentType - Document type (STATEMENT, TAX_FORM, TRADE_CONFIRMATION)
     * @param {Object} dates - Optional { start_date, end_date } (YYYY-MM-DD)
     */
    getDocuments: (accountNumber, documentType, dates = {}) => {
      const params = new URLSearchParams()
      if (documentType) {
        params.append('document_type', documentType)
      }
      if (dates.start_date) {
        params.append('start_date', dates.start_date)
      }
      if (dates.end_date) {
        params.append('end_date', dates.end_date)
      }
      return axiosInstance.get(
        `documents/${accountNumber}?${params.toString()}`
      )
    },
  }
}

const documentsApi = createDocumentsApi()

export { documentsApi }
